<template>
  <div id="app">
    <LoginPage v-if="!isLoggedIn" @login-success="handleLoginSuccess" />
    <Home v-else :user-info="userInfo" @logout="handleLogout" />
  </div>
</template>

<script>
import LoginPage from './components/LoginPage.vue'
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    LoginPage,
    Home
  },
  data() {
    return {
      isLoggedIn: false,
      userInfo: null
    }
  },
  methods: {
    handleLoginSuccess(userData) {
      this.isLoggedIn = true
      this.userInfo = {
        username: userData.username,
        loginTime: userData.loginTime,
        displayName: this.getDisplayName(userData.username)
      }
    },

    handleLogout() {
      this.isLoggedIn = false
      this.userInfo = null
    },

    getDisplayName(username) {
      const userNames = {
        'admin': '管理员',
        'cashier': '收银员',
        't6sme': 'T6sme'
      }
      return userNames[username] || username
    }
  },
  mounted() {
    // 检查本地存储的登录状态
    if (localStorage.getItem('isLoggedIn') === 'true') {
      const username = localStorage.getItem('username')
      this.handleLoginSuccess({
        username: username,
        loginTime: new Date().toISOString()
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f5f5;
}

#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
</style>
